<div class="new-content" *ngIf="!pane || !pane.loaded else contentBlock">
  <loading-line height="40px" width="100%"></loading-line>
</div>
<ng-template #contentBlock>
  <div class="chapter" *ngIf="!!blockTitle?.title">
    <app-library-title [title]="blockTitle"></app-library-title>
  </div>

  <div class="filter-block with-top">
    <div class="filter-scroll">
      <ul class="filter-list">
        <li *ngFor="let filter of categoryTabs; let i = index; trackBy: trackByFn"
            class="filter-item"
            [class.selected]="filter.id === selectedTab?.id"
            (click)="onSelectItem(filter)">
          <span
            class="filter-label">{{ filter.title | customLocale }}</span>
        </li>
      </ul>
    </div>
    <on-ui-button label="Create a course"
                  class="primary outline"
                  (onclick)="onCloseModal($event)">
    </on-ui-button>
  </div>

  <div *ngFor="let course of userServices; trackBy: trackByFn"
       class="block" >
    <app-library-course-mini [course]="course"></app-library-course-mini>
  </div>

  <ng-container *ngIf="!userServices.length" [ngTemplateOutlet]="noContentStub"></ng-container>
</ng-template>

<ng-template #noContentStub>
  <app-no-content-stub
    *ngIf="isAsIfTeacher"
    [icon]="'my-classes'"
    [text]="'my-library.stub.stub3'">
  </app-no-content-stub>
</ng-template>

<app-modal *ngIf="showModal"
           (closed)="onCloseModal($event)">
  <app-modal-body>
    В разработке...
    <!--    <app-content-form-page></app-content-form-page>-->
  </app-modal-body>
</app-modal>
